export enum Format {
    R_FORMAT,
    I_FORMAT,
    D_FORMAT,
    B_FORMAT,
    CB_FORMAT,
    IW_FORMAT,
    PSEUDO_INSTR
}